import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, range } from 'lodash';
import { SeatingChartSeat } from 'features/seating-chart';

import './SeatingChartGrid.scss';
import ArrowLeft from 'assets/svgs/arrowLeft.svg';
import SeatingChartUserIcon from 'assets/svgs/seatingChartUser.svg';

const CELL_WIDTH = 101 + 2 * 8;

class SeatingChartGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolledCols: 0,
      scrollPosition: 0,
    };
    this.scroll = this.scroll.bind(this);
    this.setVerticalScroll = this.setVerticalScroll.bind(this);
  }

  componentDidMount() {
    // if(this.props.smallRefFlag) {
    //   document.querySelector('.seating-chart-grid').addEventListener('scroll', this.setVerticalScroll);
    // }
    if (!this.props.smallRefFlag) {
      window.addEventListener('scroll', this.setVerticalScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setVerticalScroll);
  }

  setVerticalScroll() {
    // if (this.props.smallRefFlag) {
    //   const frame = document.querySelector('.seating-chart-grid');
    //   this.setState({
    //     scrollPosition: frame.scrollTop,
    //   });
    // }
    const scrollPosition = window.pageYOffset;
    const { current } = this.props.seatingChart;
    if (current) {
      if (scrollPosition > current.offsetTop + 65) {
        this.setState({
          scrollPosition: scrollPosition - (current.offsetTop + 65),
        });
      } else {
        this.setState({
          scrollPosition: 0,
        });
      }
    }
  }

  scroll(direction) {
    const { cols, maxColsDisplayed } = this.props;
    this.setState((prevState) => ({
      scrolledCols:
        direction === 'right'
          ? prevState.scrolledCols === cols - maxColsDisplayed
            ? prevState.scrolledCols
            : prevState.scrolledCols + 1
          : prevState.scrolledCols === 0
          ? prevState.scrolledCols
          : prevState.scrolledCols - 1,
    }));

    if (this.props.smallRefFlag && navigator.userAgent.indexOf('Firefox') !== -1) {
      document.querySelector('.grid-content-scroll, .grid-content').scrollLeft +=
        direction === 'left' ? -CELL_WIDTH : CELL_WIDTH;
      return;
    }

    if (window.scrollBy) {
      document.querySelector('.grid-content-scroll, .grid-content').scrollBy({
        behavior: 'smooth',
        left: direction === 'left' ? -CELL_WIDTH : CELL_WIDTH,
      });
    } else {
      document.querySelector('.grid-content-scroll, .grid-content').scrollLeft +=
        direction === 'left' ? -CELL_WIDTH : CELL_WIDTH;
    }
  }

  render() {
    const {
      rows,
      cols,
      handleSeatClick,
      seatsData,
      roomTypeMaterialTypes,
      maxColsDisplayed,
      handleBlur,
      hasNowManagedFlag,
    } = this.props;

    const { scrolledCols } = this.state;

    const divStyle = {
      width: cols > maxColsDisplayed ? `${cols * CELL_WIDTH + 10}px` : 'min-content',
      margin: '0 auto',
    };

    const scrollStyle = {
      position: 'sticky',
      top: this.state.scrollPosition,
    };

    return (
      <div className="seating-chart-grid" id="seating-chart-grid">
        <div className={`btn-scroll ${!scrolledCols && 'disabled'}`}>
          {cols > maxColsDisplayed && (
            <React.Fragment>
              <ArrowLeft onClick={() => this.scroll('left')} />
            </React.Fragment>
          )}
        </div>

        <div className="grid-content-scroll">
          <div className="grid-content" style={divStyle}>
            <div className="grid-row header-row">
              <div className="cell-letter">&nbsp;</div>
              {range(0, cols).map((i) => (
                <div className="cell" key={`header-${i}`}>
                  {`${i + 1} (${this.props.t('seatingChart.frontLabel')})`}
                </div>
              ))}
            </div>
            {range(0, rows).map((i) => (
              <div className="grid-row" key={`row-${i}`}>
                <div className="cell-letter">{String.fromCharCode('A'.charCodeAt(0) + i)}</div>
                {range(0, cols).map((j) => (
                  <SeatingChartSeat
                    key={`cell-${i}-${j}`}
                    {...this.props}
                    data={!isEmpty(seatsData[i]) ? seatsData[i][j] : null}
                    handleClick={(data) => handleSeatClick(i, j, data)}
                    cellKey={`${i}-${j}`}
                    roomTypeMaterialTypes={roomTypeMaterialTypes}
                    row={i}
                    col={j}
                    index={i * cols + j}
                    handleBlur={handleBlur}
                    hasNowManagedFlag={hasNowManagedFlag}
                  />
                ))}
              </div>
            ))}
            <div style={scrollStyle}>
              <div className="grid-row footer-row">
                <div className="cell-letter"></div>
                {range(0, cols).map((i) => (
                  <div className="cell" key={`footer-${i}`}>
                    <SeatingChartUserIcon />
                    {i + 1} ({this.props.t('seatingChart.backLabel')})
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className={`btn-scroll ${scrolledCols === cols - maxColsDisplayed && 'disabled'}`}>
          {cols > maxColsDisplayed && (
            <React.Fragment>
              <ArrowLeft onClick={() => this.scroll('right')} />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

SeatingChartGrid.defaultProps = {
  maxColsDisplayed: 9,
  smallRefFlag: false,
};

SeatingChartGrid.propTypes = {
  cols: PropTypes.number.isRequired,
  rows: PropTypes.number.isRequired,
  smallRefFlag: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SeatingChartGrid);
